//  entur-ace.js
//
//  Entur/Telia ACE interact customer specific integration scripts
//
// ReSharper disable Es6Feature

// TODO Abstract, modularize, stadardize, make nice...

// HACK In release we inject this setting object using Octopus Deploy
//centuri.entur = centuri.entur || {};
//centuri.entur.settings = centuri.entur.settings ||
//{
//    jsApiUrl: 'https://cgedgestage.labbn.se/enClient/JSApi/JSApi.js?company=teliasonera',
//    supportModel: { // localhost
//        caseflowConfigId: '22f3c08b-9c1c-4d14-b2e6-21d7db56161b',
//        updateFormId: 'f82068cb-70dd-45e2-99f2-4b404d7a0b91',
//        sendForProcessingId: '2517291a-8c95-4f4a-b4fe-b6fbe7ba2189'
//    },
//    properties: [
//        { centuriKey: 'TITLE', aceKey: 'contactId', resolver: (value) => 'Supportärende ' + value },
//        { centuriKey: 'FIRSTNAME', aceKey: 'entCustomerFirstName' },
//        { centuriKey: 'LASTNAME', aceKey: 'entCustomerLastName' },
//        { centuriKey: 'TELEPHONE', aceKey: 'Ani' },
//        { centuriKey: 'MOBILE', aceKey: 'enCustomerTelephone' },
//        { centuriKey: 'EMAIL', aceKey: 'entCustomerEmail' },
//        { centuriKey: 'OPERATOR', aceKey: 'operator' },
//        { centuriKey: 'PRODUCT', aceKey: 'product' },
//        { centuriKey: 'OPERATION', aceKey: 'operation' },
//        { centuriKey: 'DETAILS', aceKey: 'details' },
//        { centuriKey: 'COMMENT', aceKey: 'comment' }
//    ]
//};

(function($, centuri) {
    function onLoad() {
        if (!window.ACE) {
            console.log(
                '%c  Expected ACE interaction, check API URL  ',
                'background: red; color: white;');
            return;
        }

        if (!centuri.entur.settings.supportModel) {
            console.log(
                '%c  ACE Interact loaded, Customer specific settings incomplete ',
                'background: red; color: white;');
            return;
        }

        var baseUrl = [location.protocol, centuri.webAPIUrl].join('');
        var supportModel = centuri.entur.settings.supportModel;
        var properties = centuri.entur.settings.properties;

        function setUrl(url, cardSuffix) {
            window.ACE.JSApi.openCustomContent({
                url: url,
                title: 'Centuri',
                customCardId: 'centuri' + cardSuffix
            });
        }

        /*
        Steg 3:
        Centuri lyssnar på JS-APIt för att se när en ny kontakt inkommit. På detta sätt kan träfflistan (Centuri kortet i CallGuide) med aktuella ärenden för kundnumren/a-numret.
        */
        function onAfterNormalAccept(data) {
            var contactData = data.contact.contactData;

            if (contactData.Menuchoice !== 'Gruppereiser') return;

            var searchParam = contactData.entCustomerUUID ||
                (contactData.media === 'call'
                    ? contactData.Ani
                    : contactData.entCustomerEmail);

            var url = [baseUrl, '/#/case/search?query=', encodeURIComponent(searchParam || ''), '&$orderBy=updatedwhen%20desc'].join('');
            setUrl(url);
        }

        /*
        Steg 4b - Om ärende Support:
        Agenten skapar manuellt via knapp ett nytt ärende i Centuri. När detta görs ska Centuri hämta kontaktdata via JSAPI för att kunna förifylla supportformuläret.
        */
        function onApiCallback(response) {
            var url = [baseUrl, '/#/todo/workflow/', response.caseflowId, '/activity/', supportModel.updateFormId].join('');
            setUrl(url, 'support');
        }

        function onBeforeAnythingThatNeedsLogin(data, callback) {
            var ticket = localStorage.getItem('centuri/ticket');
            callback(data, { 'CENTURI-Authorization': ticket });
        }

        function getUniqueContactId(contactId) {
            return ['3', moment().format('YYMMDD'), String(contactId).slice(-9)].join('');
        }

        function onManualScreenPop(data, headers) {
            var contactData = data.contact.contactData;

            var url = [baseUrl, '/v1/caseflow/regno/', getUniqueContactId(contactData.contactId)].join('');

            var apiData = {
                caseflowConfigId: supportModel.caseflowConfigId,
                fieldValues: properties.map(function(prop) {
                    var result = { 'property': prop.centuriKey };

                    result.values = $.isFunction(prop.resolver)
                        ? [prop.resolver(contactData[prop.aceKey])]
                        : [contactData[prop.aceKey]];

                    return result;
                }),
                activities: [
                    {
                        index: 0,
                        activityId: supportModel.sendForProcessingId
                    }
                ]
            };

            $.post({
                url: url,
                data: JSON.stringify(apiData),
                success: onApiCallback,
                accept: 'application/json',
                contentType: 'application/json',
                headers: headers
            })
            .fail(function() {
                // TODO Handle error?
                console.log(
                    '%c  An error occured onManualScreenPop  ',
                    'background: red; color: white');
            });
        }

        // Listen to screen pop events
        function onScreenPop(data) {
            var screenPopType = data.popEvent;

            switch (screenPopType) {
            case 'afterNormalAccept':
                onBeforeAnythingThatNeedsLogin(data, onAfterNormalAccept);
                break;
            case 'manual':
                onBeforeAnythingThatNeedsLogin(data, onManualScreenPop);
                break;
            }
        }

        window.ACE.JSApi.onScreenPop(onScreenPop);
    }

    centuri.entur = centuri.entur || {};
    centuri.entur.connectToAce = function() {
        var settings = centuri.entur.settings;
        if (!settings ||
            !settings.jsApiUrl) {
            console.log(
                '%c  ACE interaction endpoint not detected  ',
                'background: yellow; color: black;');
            return;
        }

        var s = document.createElement('script');
        s.src = centuri.entur.settings.jsApiUrl;
        s.onload = onLoad;
        document.body.appendChild(s);
    };

})($, window.centuri);

window.centuri.entur.connectToAce();